(function () {
  'use strict';


  angular
    .module('crewing')
    .controller('DelayedReportTimingCtrl', DelayedReportTimingCtrl);

  function DelayedReportTimingCtrl($uibModalInstance, modalParams,CrewingHelper,MessageService) {
    var vm = this;

    vm.isDisabledInputItems = true;
    vm.applyDateTimeToAll = false;



    vm.model = {
      title: modalParams.title,
      delayedReportTimingList:[],
      timeBufferForSignIn:'',
      showReduceRestColumn: false,
      showMaxDutyHrLimit: false
    };
    getDelayedReportTimings();

    function getDelayedReportTimings(){
      CrewingHelper.getDelayedReportTiming({blockId:modalParams.selectedDuty.blockId}, function (data) {
        vm.model.delayedReportTimingList= adaptDelayReportTimeData(data);
        vm.model.timeBufferForSignIn=data.timeBufferForSignIn;
        vm.model.showReduceRestColumn= data.showReduceRest;
        vm.model.showMaxDutyHrLimit= data.showMaxDutyHrLimit;
        },
        function (msg) {
          MessageService.error('Failed to load duty time regulator.');
        })
    }

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    };

    vm.onYesClick = function(){
      $uibModalInstance.close('YES');
    };

    vm.onNoClick = function(){
      $uibModalInstance.close();
    };

    vm.onClickUpdate=function () {
      vm.isDisabledInputItems = false;

    }

    vm.onClickSave=function () {
      handleSave();
    }

    vm.changeAny = function (event) {
      //call this method in on change in date to stop crashing the front end
    };

    function adaptDelayReportTimeData(data) {
      var transformedData = [];

      data.delayedReportingDTOs.forEach(function (crew) {

        var checkIn = splitDateTime(crew.checkInDateTime);
        var checkOut = splitDateTime(crew.checkOutDateTime);
        var originalCheckIn = splitDateTime(crew.originalCheckInDateTime);
        var signIn = splitDateTime(crew.signInDateTime);

        transformedData.push({
          crewId: crew.crewId,
          crewScheduleBlockId:crew.crewScheduleBlockId,
          crewName: crew.crewName,
          crewType: crew.crewType,
          checkInDate: checkIn[0],
          checkInTime: checkIn[1],
          signInDate: signIn[0],
          signInTime: signIn[1],
          checkOutDate: checkOut[0],
          checkOutTime: checkOut[1],
          maxFDP: crew.maxFdp,
          blockFDP: crew.blockFdp,
          dutyHrs: crew.dutyHours,
          dutyHrsDecimal: (function() {
            if (!crew.dutyHours) return null;
            var parts = crew.dutyHours.split(':');
            return parseInt(parts[0]) + (parts[1] ? parseInt(parts[1]) / 60 : 0);
          })(),
          maxDutyHrLimit: crew.maxDutyHrLimit,
          maxDutyHrLimitDecimal: (function() {
            if (!crew.maxDutyHrLimit) return null;
            var parts = crew.maxDutyHrLimit.split(':');
            return parseInt(parts[0]) + (parts[1] ? parseInt(parts[1]) / 60 : 0);
          })(),
          sbyCallOut: crew.sbyCallOut,
          delayedReporting: crew.delayedReporting,
          reduceRest: crew.reduceRest,
          originalCheckInDate: originalCheckIn[0],
          originalCheckInTime: originalCheckIn[1],
          hasFlightPatternUpdateSync: crew.hasFlightPatternUpdateSync,
          isSignInTimeEditable: crew.isSignInTimeEditable
        });

      });

      return transformedData;

    }

    function splitDateTime(dateTimeStr) {
      if (!dateTimeStr) return ["", ""];

      var parts = dateTimeStr.split(" ");
      return [parts[0], parts[1].substring(0, 5)];
    }



    function handleSave(){

      var invalidCheckinCheckoutRecords = vm.model.delayedReportTimingList.some(vm.isInvalidCheckinCheckOutTiming);
      var invalidCheckInOriginalCheckinRecords = vm.model.delayedReportTimingList.some(vm.isInvalidCheckinOriginalCheckinTiming);
      var invalidOriginalCheckinTime = vm.model.delayedReportTimingList.some(vm.isOriginalCheckinTimeBehind);
      var invalidSignInTime = vm.model.delayedReportTimingList.some(vm.isSignInTimeExceeding24Hours);

      if (invalidCheckinCheckoutRecords) {
        MessageService.error('Check-in time should not be greater than check-out time. Please correct the records before saving.');
        vm.isDisabledInputItems = false;
        return;
      }

      if (invalidCheckInOriginalCheckinRecords) {
        MessageService.error('Original check in should not be greater than or equal to the check in time. Please correct the records before saving.');
        vm.isDisabledInputItems = false;
        return;
      }

      if (invalidOriginalCheckinTime) {
        MessageService.error('Original check-in time should not be more than 20 hours behind the check-in time. Please correct the records before saving.');
        vm.isDisabledInputItems = false;
        return;
      }

      if (invalidSignInTime) {
        var hoursBuffer = vm.model.timeBufferForSignIn / 60;
        MessageService.error('Sign-in date time and check-in date time should not be greater/lesser than ' + hoursBuffer + ' hours');
        vm.isDisabledInputItems = false;
        return;
      }


      var request=createDelayReportTimeRequest()
      CrewingHelper.updateDelayedReportTiming(request, function (data) {
          getDelayedReportTimings();
          MessageService.success('Successfully updated the duty time regulator.');
          vm.isDisabledInputItems = true;
        },
        function (msg) {
          MessageService.error('Failed to update the duty time regulator.');
          vm.isDisabledInputItems = false;
        })
    }

    function createDelayReportTimeRequest() {
      var editedDelayedReportTimingData=[];
      vm.model.delayedReportTimingList.forEach(function (crew) {
        editedDelayedReportTimingData.push({
          crewId: crew.crewId,
          crewScheduleBlockId: crew.crewScheduleBlockId,
          checkinDateTimeString: parseDateTime(crew.checkInDate, crew.checkInTime),
          signInDateTimeString: parseDateTime(crew.signInDate, crew.signInTime),
          checkOutDateTimeString: parseDateTime(crew.checkOutDate, crew.checkOutTime),
          delayedReportingBool: crew.delayedReporting,
          reduceRest: crew.reduceRest,
          originalCheckInDateTimeString: parseDateTime(crew.originalCheckInDate, crew.originalCheckInTime),

        })
      })
      return {
        editedDelayedReportingList: editedDelayedReportTimingData
      };
    }


    function parseDateTime(dateStr,timeStr) {
      if (!dateStr.trim() || !timeStr.trim()) {
        return null;
      }
      return dateStr + " " + timeStr;
    }

    vm.isInvalidCheckinCheckOutTiming = function (delayedTiming) {
      if (!delayedTiming.checkInDate || !delayedTiming.checkInTime || !delayedTiming.checkOutDate || !delayedTiming.checkOutTime) {
        return false;
      }

      var checkInDateTime = parseDateTimeForValidation(delayedTiming.checkInDate, delayedTiming.checkInTime);
      var checkOutDateTime = parseDateTimeForValidation(delayedTiming.checkOutDate, delayedTiming.checkOutTime);

      return checkInDateTime >= checkOutDateTime;
    };

    vm.isInvalidCheckinOriginalCheckinTiming = function (delayedTiming) {
      if (!delayedTiming.checkInDate || !delayedTiming.checkInTime ) {
        return false;
      }

      var checkInDateTime = parseDateTimeForValidation(delayedTiming.checkInDate, delayedTiming.checkInTime);

      if (delayedTiming.originalCheckInDate && delayedTiming.originalCheckInTime) {
        var originalCheckInDateTime = parseDateTimeForValidation(delayedTiming.originalCheckInDate, delayedTiming.originalCheckInTime);
        return originalCheckInDateTime >= checkInDateTime
      }

      return false;
    };


    vm.isOriginalCheckinTimeBehind = function (delayedTiming) {
      if (!delayedTiming.checkInDate || !delayedTiming.checkInTime) {
        return false;
      }

      var checkInDateTime = parseDateTimeForValidation(delayedTiming.checkInDate, delayedTiming.checkInTime);

      if (delayedTiming.originalCheckInDate && delayedTiming.originalCheckInTime) {
        var originalCheckInDateTime = parseDateTimeForValidation(delayedTiming.originalCheckInDate, delayedTiming.originalCheckInTime);
        var twentyHoursInMillis = 20 * 60 * 60 * 1000;
        return (checkInDateTime - originalCheckInDateTime) > twentyHoursInMillis;
      }

      return false;
    };

    vm.isSignInTimeExceeding24Hours = function (delayedTiming) {
      // If check-in date/time is not available, don't validate sign-in
      if (!delayedTiming.checkInDate || !delayedTiming.checkInTime) {
        return false;
      }

      // If sign-in date/time is not provided, no validation needed
      if (!delayedTiming.signInDate || !delayedTiming.signInTime) {
        return false;
      }

      var checkInDateTime = parseDateTimeForValidation(delayedTiming.checkInDate, delayedTiming.checkInTime);
      var signInDateTime = parseDateTimeForValidation(delayedTiming.signInDate, delayedTiming.signInTime);

      // Calculate time difference in milliseconds
      var timeDifference = Math.abs(signInDateTime - checkInDateTime);

      // 24 hours in milliseconds
      var twentyFourHoursInMillis = vm.model.timeBufferForSignIn * 60 * 1000;

      // Return true if time difference exceeds 24 hours
      return timeDifference > twentyFourHoursInMillis;
    };





    function parseDateTimeForValidation(dateStr, timeStr) {
      var parts = dateStr.split("/"); // Split dd/MM/yyyy
      var timeParts = timeStr.split(":"); // Split HH:mm

      return new Date(parts[2], parts[1] - 1, parts[0], timeParts[0], timeParts[1]);
    }


    vm.applyDateToAll=function () {

      if (!vm.model.delayedReportTimingList || vm.model.delayedReportTimingList.length === 0) {
        MessageService.error('No crew members available to apply date.');
        return;
      }


      var dateToApply = vm.model.delayedReportTimingList[0].originalCheckInDate;
      var timeToApply = vm.model.delayedReportTimingList[0].originalCheckInTime;

      if (!dateToApply || !timeToApply) {
        MessageService.error('Please select a valid date and time to apply to all crew members.');
        return;
      }

      if(vm.applyDateTimeToAll && dateToApply && timeToApply) {
        vm.model.delayedReportTimingList.forEach(function (crew) {
          if(!crew.originalCheckInDate&&!crew.originalCheckInTime){
            crew.originalCheckInDate = dateToApply;
            crew.originalCheckInTime = timeToApply;
            crew.delayedReporting = true;
          }

        });
      }else{
        vm.model.delayedReportTimingList.forEach(function (crew, index) {
          if (index > 0) {  // Skip the first record

            if( crew.originalCheckInDate===dateToApply&& crew.originalCheckInTime===timeToApply){
              crew.originalCheckInDate = "";
              crew.originalCheckInTime = "";
              crew.delayedReporting = false;
            }
          }
        });
      }


    }










  }
}());
